import { updateDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/firebase';
import { IUser } from '@/types/Collections/users';

export const updateProfile = (
  uid: string,
  data: Partial<IUser>,
): Promise<boolean> =>
  updateDoc(doc(db, 'users', uid), data)
    .then(() => true)
    .catch(() => false);
